/**
 * 可排班的商品 — 班次管理三頁（排班、班次列表、班次編輯）共用。
 *
 * 套票**不建班次**：它只定義「含哪些商品」，座位由組成商品的真實班次承擔
 * （見 migration 20260821010000）。後端對套票的建班次請求一律回 400，但把它留在
 * 下拉裡的話，營運要填完整張表單（日期、週期、時段、容量）按下送出才會知道——
 * 錯誤來得比該來的時候晚了一整個表單。
 *
 * 三頁各寫一份 filter 的話，只會有其中一頁記得補。
 */

import type { ProductSummary } from './api/products';

/** 未軟刪 + 非套票。 */
export function schedulableProducts(items: readonly ProductSummary[]): ProductSummary[] {
  return items.filter((p) => p.deleted_at === null && p.category !== 'package');
}

/** 下拉旁的說明——不解釋的話，營運只會覺得自己的套票「不見了」。 */
export const SCHEDULABLE_HINT =
  '套票不建班次（座位由組成商品承擔），故不列於此；其組成請於商品頁設定。';
